import { groq } from 'next-sanity'

export const contactDetailsQuery = groq`
  *[_type == "contactDetails"][0] {
    addressLine1,
    addressLine2,
    city,
    postcode,
    phone,
    phoneRaw,
    email,
    companyRegistration
  }
`

export const teamMembersQuery = groq`
  *[_type == "teamMember"] | order(order asc, name asc) {
    _id,
    name,
    role,
    company,
    bio,
    email,
    image,
    featured
  }
`


